import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mobile-sidebar-header"
}
const _hoisted_2 = {
  key: 1,
  class: "d-flex align-center"
}
const _hoisted_3 = {
  key: 0,
  class: "history-section"
}
const _hoisted_4 = { class: "history-header" }
const _hoisted_5 = {
  key: 0,
  class: "agent-filter-chip"
}
const _hoisted_6 = { class: "agent-filter-name" }
const _hoisted_7 = { class: "conversation-list" }
const _hoisted_8 = {
  key: 1,
  class: "empty-history"
}
const _hoisted_9 = { class: "conversation-actions" }
const _hoisted_10 = { class: "load-more-trigger" }

import ottuLogo from '@/assets/ottu-logo.svg';
import DeleteConversationDialog from '@/components/DeleteConversationDialog.vue';
import RenameConversationDialog from '@/components/RenameConversationDialog.vue';
import { Agent } from '@/services/agentService';
import { type Conversation } from '@/services/conversationService';
import { useAgentStore } from '@/stores/agentStore';
import { useConversationStore } from '@/stores/conversationStore';
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppSidebar',
  props: {
    drawer: { type: Boolean },
    rail: { type: Boolean },
    isMobile: { type: Boolean },
    agents: {},
    conversations: {}
  },
  emits: ["update:drawer", "update:rail", "new-chat", "select-conversation", "open-search", "go-home"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const route = useRoute();
const agentStore = useAgentStore();
const conversationStore = useConversationStore();

const emit = __emit;

const expanded = ref(false);

const activeFilterAgent = computed(() =>
  conversationStore.activeAgentFilter
    ? agentStore.getAgentById(conversationStore.activeAgentFilter)
    : null,
);
const showDeleteDialog = ref(false);
const conversationToDelete = ref<Conversation | null>(null);
const showRenameDialog = ref(false);
const conversationToRename = ref<Conversation | null>(null);

const drawer = computed({
  get: () => props.drawer,
  set: (value) => emit('update:drawer', value),
});

const rail = computed({
  get: () => props.rail,
  set: (value) => emit('update:rail', value),
});

const handleOutsideClick = () => {
  if (expanded.value) {
    expanded.value = false;
  }
};

const openRenameDialog = (conversation: Conversation) => {
  conversationToRename.value = conversation;
  showRenameDialog.value = true;
};

const openDeleteDialog = (conversation: Conversation) => {
  conversationToDelete.value = conversation;
  showDeleteDialog.value = true;
};

const onIntersect = (isIntersecting: boolean) => {
  if (
    isIntersecting &&
    conversationStore.hasMore &&
    !conversationStore.isLoading
  ) {
    conversationStore.loadMoreConversations();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_fade_transition = _resolveComponent("v-fade-transition")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _directive_click_outside = _resolveDirective("click-outside")!
  const _directive_intersect = _resolveDirective("intersect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_navigation_drawer, {
      modelValue: drawer.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((drawer).value = $event)),
      app: "",
      permanent: !_ctx.isMobile,
      temporary: _ctx.isMobile,
      "rail-width": "72",
      width: "324",
      rail: _ctx.isMobile ? false : rail.value
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(`${rail.value || _ctx.isMobile ? 'px-4' : 'px-6'} py-4 sidebar`)
        }, [
          (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_img, {
                  src: _unref(ottuLogo),
                  alt: "Ottu Logo",
                  class: "sidebar-logo",
                  onClick: _cache[0] || (_cache[0] = 
            () => {
              drawer.value = false;
              _ctx.$emit(`go-home`);
            }
          )
                }, null, 8, ["src"]),
                _createVNode(_component_v_btn, {
                  icon: "",
                  size: "40",
                  variant: "text",
                  ripple: false,
                  class: "menu-icon",
                  "aria-label": "Close navigation menu",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (drawer.value = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: 24,
                      "aria-hidden": "true"
                    }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createTextVNode("mdi-backburger", -1)
                      ])),
                      _: 1,
                      __: [9]
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_v_btn, {
                  icon: "",
                  size: "40",
                  ripple: false,
                  class: "ml-auto menu-icon",
                  "aria-label": rail.value ? 'Expand sidebar' : 'Collapse sidebar',
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (rail.value = !rail.value))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: 24,
                      "aria-hidden": "true"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(rail.value ? 'mdi-menu' : 'mdi-backburger'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["aria-label"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_fade_transition, null, {
            default: _withCtx(() => [
              (_ctx.isMobile || !rail.value)
                ? _withDirectives((_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "agent-selector",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (expanded.value = !expanded.value))
                  }, [
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      class: "agent-selector-btn"
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          size: 24,
                          class: "text-white"
                        }, {
                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                            _createTextVNode("mdi-comment-edit-outline", -1)
                          ])),
                          _: 1,
                          __: [10]
                        })
                      ]),
                      append: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          size: 24,
                          class: "text-white"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(expanded.value ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "new-chat-text" }, _toDisplayString('New Chat'), -1))
                      ]),
                      _: 1,
                      __: [11]
                    }),
                    _createVNode(_component_v_expand_transition, null, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", null, [
                          _createVNode(_component_v_list, {
                            density: "compact",
                            class: "pa-0"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agents, (agent) => {
                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: agent.name,
                                  class: "agent-item",
                                  onClick: ($event: any) => (_ctx.$emit('new-chat', agent))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, { class: "agent-item-title" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(agent.name), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ], 512), [
                          [_vShow, expanded.value]
                        ])
                      ]),
                      _: 1
                    })
                  ])), [
                    [_directive_click_outside, handleOutsideClick]
                  ])
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_fade_transition, null, {
            default: _withCtx(() => [
              (_ctx.isMobile || !rail.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "search-chats-btn",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('open-search')))
                  }, [
                    _createVNode(_component_v_icon, {
                      size: 24,
                      "aria-hidden": "true"
                    }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode("mdi-magnify", -1)
                      ])),
                      _: 1,
                      __: [12]
                    }),
                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "search-chats-text" }, "Search Chats", -1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_fade_transition, null, {
            default: _withCtx(() => [
              (_ctx.isMobile || !rail.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "history-title" }, "History", -1)),
                      (activeFilterAgent.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "agent-filter-bracket" }, "[", -1)),
                            _createElementVNode("span", _hoisted_6, _toDisplayString(activeFilterAgent.value.name), 1),
                            _createVNode(_component_v_icon, {
                              size: "16",
                              class: "agent-filter-close",
                              "aria-label": "Clear agent filter",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(conversationStore).setAgentFilter(null)))
                            }, {
                              default: _withCtx(() => _cache[14] || (_cache[14] = [
                                _createTextVNode("mdi-close-circle-outline", -1)
                              ])),
                              _: 1,
                              __: [14]
                            }),
                            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "agent-filter-bracket" }, "]", -1))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      (_unref(conversationStore).isLoading && _ctx.conversations.length === 0)
                        ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                            key: 0,
                            type: `list-item@${_unref(conversationStore).limit}`
                          }, null, 8, ["type"]))
                        : (_ctx.conversations.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createVNode(_component_v_icon, {
                                size: "32",
                                class: "empty-history-icon"
                              }, {
                                default: _withCtx(() => _cache[18] || (_cache[18] = [
                                  _createTextVNode("mdi-chat-outline", -1)
                                ])),
                                _: 1,
                                __: [18]
                              }),
                              _cache[19] || (_cache[19] = _createElementVNode("p", { class: "empty-history-title" }, "No chats yet", -1)),
                              _cache[20] || (_cache[20] = _createElementVNode("p", { class: "empty-history-subtitle" }, " Start a new chat to begin a conversation ", -1))
                            ]))
                          : (_openBlock(), _createBlock(_component_v_list, {
                              key: 2,
                              density: "compact",
                              class: "pa-0"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conversations, (conversation) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: conversation.id,
                                    active: 
                  _unref(route).name === 'conversation' &&
                  _unref(route).params.id === conversation.id
                ,
                                    class: "rounded mb-3 pa-3",
                                    onClick: ($event: any) => (
                  _unref(route).params.id !== conversation.id &&
                    _ctx.$emit('select-conversation', conversation)
                )
                                  }, {
                                    append: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_9, [
                                        _createVNode(_component_v_btn, {
                                          icon: "",
                                          size: "x-small",
                                          variant: "text",
                                          color: "white",
                                          "aria-label": "Rename conversation",
                                          onClick: _withModifiers(($event: any) => (openRenameDialog(conversation)), ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              size: 18,
                                              "aria-hidden": "true"
                                            }, {
                                              default: _withCtx(() => _cache[21] || (_cache[21] = [
                                                _createTextVNode("mdi-rename-box-outline", -1)
                                              ])),
                                              _: 1,
                                              __: [21]
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_component_v_btn, {
                                          icon: "",
                                          size: "x-small",
                                          variant: "text",
                                          color: "white",
                                          "aria-label": "Delete conversation",
                                          onClick: _withModifiers(($event: any) => (openDeleteDialog(conversation)), ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              size: 18,
                                              "aria-hidden": "true"
                                            }, {
                                              default: _withCtx(() => _cache[22] || (_cache[22] = [
                                                _createTextVNode("mdi-delete-outline", -1)
                                              ])),
                                              _: 1,
                                              __: [22]
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { class: "conversation-title" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(conversation.title || conversation.id), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["active", "onClick"]))
                                }), 128)),
                                _withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [
                                  [_directive_intersect, onIntersect]
                                ]),
                                (_unref(conversationStore).isLoading && _ctx.conversations.length > 0)
                                  ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                                      key: 0,
                                      type: "list-item@3"
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ], 2)
      ]),
      _: 1
    }, 8, ["modelValue", "permanent", "temporary", "rail"]),
    _createVNode(RenameConversationDialog, {
      modelValue: showRenameDialog.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showRenameDialog).value = $event)),
      conversation: conversationToRename.value
    }, null, 8, ["modelValue", "conversation"]),
    _createVNode(DeleteConversationDialog, {
      modelValue: showDeleteDialog.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showDeleteDialog).value = $event)),
      conversation: conversationToDelete.value
    }, null, 8, ["modelValue", "conversation"])
  ], 64))
}
}

})